import {Navigate, Outlet, Route, Routes, useLocation} from "react-router-dom";
import Login from "../components/auth/Login";
import {useAuth} from "../contexts/AuthContext";
import Forbidden from "../components/auth/Forbidden";
import ForgotPassword from "../components/auth/ForgotPassword";
import ResetPassword from "../components/auth/ResetPassword";
import MainLayout from "../components/layout/MainLayout";
import Logout from "../components/auth/Logout";
import React from "react";
import ChangePassword from "../components/modules/settings/ChangePassword";
import SettingsLayout from "../components/modules/settings/SettingsLayout";
import SlackIntegration from "../components/modules/settings/SlackIntegration";
import TeamSettings from "../components/modules/settings/TeamSettings";
import LoginAs from "../components/auth/LoginAs";
import Documents from "../components/modules/documents/Documents";
import Clients from "../components/modules/clients/Clients";
import ConversationList from "../components/modules/conversations/ConversationList";
import HowItWorks from "../components/modules/pages/HowItWorks";
import Inbox from "../components/modules/inbox/Inbox";
import RequestList from "../components/modules/conversations/RequestList";


export default function AiEcommRouter() {

    return (
        <>
            <Routes>

            {/*<Route element={<EmbeddedLayout />} >*/}
            {/*</Route>*/}

            <Route element={<ProtectedRoutes/>}>

                {/* Protected routes with main layout */}

                {/*<Route element={<MainLayout hideSecondaryNav={true} />}>*/}
                {/*    /!* Messenger *!/*/}
                {/*    <Route path="/messenger/*" element={<Messenger/>} />*/}
                {/*</Route>*/}

                <Route element={<MainLayout/>}>

                    <Route index element={<Inbox/>}/>
                    <Route path="chats" element={<ConversationList/>}/>
                    <Route path="chats/new" element={<ConversationList/>}/>
                    <Route path="chats/:conversationId" element={<ConversationList/>}/>
                    <Route path="requests" element={<RequestList/>}/>
                    <Route path="documents/*" element={<Documents/>}/>
                    <Route path="clients/*" element={<Clients/>}/>

                    {/*<Route path="/dashboard" element={<Dashboard/>}/>*/}
                    {/*<Route path="/forbidden" element={<Forbidden/>}/>*/}

                    <Route path="/users" element={<LoginAs/>}/>

                    {/*/!* Profile and account settings *!/*/}
                    <Route element={<SettingsLayout/>}>
                        <Route path="/settings/change-password" element={<ChangePassword/>}/>
                        <Route path="/settings/integrations/slack" element={<SlackIntegration/>}/>
                        <Route path="/settings/team" element={<TeamSettings/>}/>
                        {/*<Route path="/settings/profile" element={<EditProfile/>}/>*/}
                        {/*<Route path="/settings/subscription" element={<ManageSubscription/>}/>*/}
                        {/*<Route path="/settings/notifications" element={<Notification/>}/>*/}
                    </Route>

                </Route>

            </Route>

            {/* Public routes with no sidebar */}
            {/*<Route element={<NoSidebarLayout/>}>*/}
            {/*    <Route path="/login" element={<Login/>}/>*/}
            {/*    <Route path="/forgot-password" element={<ForgotPassword/>}/>*/}

            {/*    <Route path="reset-password">*/}
            {/*        <Route path=":token" element={<ResetPassword/>}/>*/}
            {/*        <Route path=":token/:uid" element={<ResetPassword/>}/>*/}
            {/*    </Route>*/}
            {/*</Route>*/}


            <Route element={<MainLayout/>}>
                {/* Public routes */}
                {/*<Route index element={<RequestAudit/>}/>*/}
                {/*<Route path="audit/run" element={<RequestAudit/>}/>*/}
                {/*<Route path="audit/:id/:secret" element={<AuditResult/>}/>*/}

                {/*<Route path="/support" element={<Support/>}/>*/}
                <Route path="/how-it-works" element={<HowItWorks/>}/>
                {/*<Route path="/agencies" element={<Agencies/>}/>*/}
                {/*<Route path="/pricing" element={<Pricing/>}/>*/}
                {/*<Route path="/payment-successful" element={<PaymentSuccess/>}/>*/}

                <Route path="/logout" element={<Logout/>}/>
            </Route>

            {/* Public routes with main layout */}
            <Route element={<PublicRoute/>}>
                <Route element={<MainLayout/>}>


                    {/* Auth stuff */}
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/forgot-password" element={<ForgotPassword/>}/>

                    {/*<Route path="/register" element={<Register/>}/>*/}

                    <Route path="reset-password">
                        <Route path=":token" element={<ResetPassword/>}/>
                        <Route path=":token/:uid" element={<ResetPassword/>}/>
                    </Route>
                </Route>
            </Route>


            </Routes>
        </>
    );


}

const ProtectedRoutes = () => {
    const {currentUser, loading} = useAuth()
    const location = useLocation()

    if (loading) return <></>

    return currentUser ? (
        <Outlet/>
    ) : (
        <Navigate to="/login" replace={true} state={{prev: location.pathname}}/>
    );
};

const RoleBasedRoutes = ({allowedGroups}) => {
    const {currentUser, loading} = useAuth();
    return currentUser?.groups?.find((group) =>
        allowedGroups?.includes(group)
    ) ? (
        <Outlet/>
    ) : (
        <Navigate to="/forbidden" replace={true}/>
    );
};

export const RouteWithPermissionCheck = ({requiredPermission}) => {
    const {currentUser, permissions, loading} = useAuth();
    if (loading || permissions.length === 0) return <></>;
    return currentUser?.is_superuser === true ||
    permissions.find((e) => e === requiredPermission) ? (
        <Outlet/>
    ) : (
        <Forbidden/>
    );
};

export const PublicRoute = ({requiredPermission}) => {
    const {currentUser, loading} = useAuth()
    if (loading) return <></>;
    if (currentUser) return <Navigate to="/" replace={true}/>;
    return <Outlet/>
};


